import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var AutoTranslationService;
(function (AutoTranslationService) {
    AutoTranslationService.SYMBOL = Symbol.for('AutoTranslationService');
})(AutoTranslationService || (AutoTranslationService = {}));
export default (container) => {
    let AutoTranslationServiceImpl = class AutoTranslationServiceImpl {
        extractSegmentsWithTime(event) {
            if (!event.segs || event.segs.length === 0)
                return [];
            const eventStartMs = event.tStartMs;
            const eventDurationMs = event.dDurationMs || 1000;
            const segments = [];
            for (const seg of event.segs) {
                if (!seg.utf8)
                    continue;
                const segStartMs = eventStartMs + (seg.tOffsetMs || 0);
                const duration = seg.acAsrConf === undefined ? eventDurationMs : (seg.acAsrConf || 500);
                const segEndMs = segStartMs + duration;
                segments.push({ startMs: segStartMs, endMs: segEndMs, text: seg.utf8 });
            }
            return segments;
        }
        calculateEventTiming(event) {
            const segments = this.extractSegmentsWithTime(event);
            if (segments.length === 0) {
                return { startMs: event.tStartMs, endMs: event.tStartMs + 1000 };
            }
            return { startMs: segments[0].startMs, endMs: segments[segments.length - 1].endMs };
        }
        extractTextFromEvent(event) {
            return this.extractSegmentsWithTime(event).map(s => s.text).join('').trim();
        }
        async getTranslationData(name, lang) {
            try {
                const res = await fetch(`/datas/english/auto-translation/${name}.${lang}.json`);
                const data = await res.json();
                const items = [];
                for (const event of data.events) {
                    if (!event.segs || event.segs.length === 0)
                        continue;
                    const { startMs, endMs } = this.calculateEventTiming(event);
                    const text = this.extractTextFromEvent(event);
                    if (!text)
                        continue;
                    const fixedEndMs = endMs < startMs ? startMs + 1000 : endMs;
                    items.push({ type: lang, text, startMs, endMs: fixedEndMs });
                }
                return items;
            }
            catch {
                return [];
            }
        }
        async getTranslationScript(name) {
            const [enItems, koItems] = await Promise.all([
                this.getTranslationData(name, 'en'),
                this.getTranslationData(name, 'ko'),
            ]);
            const items = [...enItems, ...koItems];
            items.sort((a, b) => {
                if (a.startMs !== b.startMs)
                    return a.startMs - b.startMs;
                if (a.type !== b.type)
                    return a.type === "en" ? -1 : 1;
                return a.endMs - b.endMs;
            });
            return items;
        }
    };
    AutoTranslationServiceImpl = __decorate([
        Sim({ symbol: AutoTranslationService.SYMBOL, container: container })
    ], AutoTranslationServiceImpl);
    return AutoTranslationServiceImpl;
};
